import { PaymentIntentData } from '@project/services';
import { PaymentIntentModelType } from './types';

export const PaymentIntentModel = (data: PaymentIntentData): PaymentIntentModelType => ({
  clientSecret: data?.client_secret ?? '',
  id: data?.id ?? '',
});
